module.exports = __webpack_public_path__ + "img/referencement_local.5d5056a7.png";